import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      setDone(true);
      toast.success("Thank you — you're on the list.");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="container-x py-24 sm:py-32" data-testid="newsletter-section">
      <div className="grid gap-12 border-t border-[#E5E0D8] pt-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="eyebrow">Letters from the studio</p>
          <h2 className="mt-5 font-display text-4xl font-light leading-tight sm:text-5xl">New work, quietly announced.</h2>
        </div>
        <div className="md:col-span-6 md:col-start-7 md:pt-10">
          <p className="max-w-md text-sm leading-relaxed text-[#5A626A]">
            Occasional notes from the studio and first word when new paintings are finished. No noise — unsubscribe whenever you like.
          </p>
          {done ? (
            <p className="mt-10 font-display text-2xl italic" data-testid="newsletter-success">Thank you. You'll hear from the studio soon.</p>
          ) : (
            <form onSubmit={submit} className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-end">
              <label className="flex-1">
                <span className="field-label">Email address</span>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="field" data-testid="newsletter-email-input" />
              </label>
              <button type="submit" disabled={busy} className="btn-primary" data-testid="newsletter-submit-button">
                {busy ? "Subscribing…" : "Subscribe"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
